export default __webpack_public_path__ + "static/singapore-b08d2d495be78b9f8b38f44cbe5002d2.png";